export default __webpack_public_path__ + "static/media/simon_active.f092a322.svg";